import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { CreditCard } from "lucide-react";

interface IModeOfPayment {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

export function ModeOfPayment(props: IModeOfPayment) {
    const { value, onChange, loading } = { ...props };
    const [modeOfPayment, setModeOfPayment] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setModeOfPayment(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setModeOfPayment(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Mode of Payment
            </Typography>

            <Select
                placeholder="Select payment mode"
                value={modeOfPayment}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<CreditCard size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="Cash">Cash</Option>
                <Option value="Credit Card">Credit Card</Option>
                <Option value="Debit Card">Debit Card</Option>
                <Option value="Bank Transfer">Bank Transfer</Option>
                <Option value="Check">Check</Option>
                <Option value="Other">Other</Option>
            </Select>
        </Box>
    );
}
